import { useState, useEffect } from 'react';

const LOGO_URL = 'https://storage.readdy-site.link/project_files/631a32e5-64ad-4b7f-9425-a4311af1ac5d/489447e0-737c-4cbe-9c4f-314d2065be72_shadowfax-logo.webp?v=d8a20a74b4bef28b4f74cdde96a08adc';

function LogoImage() {
  return (
    <img
      src={LOGO_URL}
      alt="Shadowfax Roofing & Solar"
      className="w-auto object-contain block"
      style={{ height: '48px' }}
    />
  );
}

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-[#e8e8e4]"
      style={{ height: '80px' }}
    >
      <div className="w-full px-6 lg:px-10 h-full flex items-center justify-between">
        {/* Logo */}
        <a
          href="#home"
          onClick={(e) => { e.preventDefault(); handleNav('#home'); }}
          className="flex items-center flex-shrink-0 cursor-pointer"
          aria-label="Shadowfax Roofing & Solar — Home"
        >
          <LogoImage />
        </a>

        {/* Desktop — center nav (Home only) */}
        <nav className="hidden md:flex items-center">
          <button
            onClick={() => handleNav('#home')}
            className="text-xs uppercase tracking-[2px] font-semibold text-[#1a1a1a]/60 hover:text-[#1a1a1a] transition-colors duration-300 cursor-pointer whitespace-nowrap px-4 py-2"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Home
          </button>
        </nav>

        {/* Right cluster */}
        <div className="hidden md:flex items-center gap-4">
          {/* Phone */}
          <a
            href="tel:4086280065"
            className="flex items-center gap-2 transition-colors duration-300 whitespace-nowrap group"
          >
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#d4af37]/10">
              <i className="ri-phone-fill text-[#d4af37] text-sm"></i>
            </div>
            <div>
              <p className="text-[10px] uppercase tracking-wider leading-none mb-0.5 text-[#999]">Call Now</p>
              <p className="text-sm font-bold leading-none text-[#1a1a1a] group-hover:text-[#d4af37] transition-colors">
                (408) 628-0065
              </p>
            </div>
          </a>

          {/* Divider */}
          <div className="w-px h-8 bg-[#e8e8e4]"></div>

          {/* CTA */}
          <button
            onClick={() => handleNav('#contact')}
            className="bg-[#d4af37] hover:bg-[#c4a030] text-[#1a1a1a] font-bold text-xs px-6 py-3 rounded transition-all duration-300 whitespace-nowrap uppercase tracking-[1.5px] cursor-pointer"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Get Free Estimate
          </button>
        </div>

        {/* Mobile hamburger */}
        <div className="md:hidden flex items-center gap-3">
          <a
            href="tel:4086280065"
            className="flex items-center justify-center w-10 h-10 rounded-full bg-[#d4af37]/10"
            aria-label="Call Shadowfax Roofing"
          >
            <i className="ri-phone-fill text-[#d4af37] text-lg"></i>
          </a>
          <button
            className="w-10 h-10 flex items-center justify-center cursor-pointer text-[#1a1a1a]"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#f0f0ec] px-6 py-6 flex flex-col gap-5">
          <button
            onClick={() => handleNav('#home')}
            className="text-[#1a1a1a]/70 hover:text-[#1a1a1a] text-xs uppercase tracking-[2px] text-left font-semibold cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Home
          </button>
          <div className="border-t border-[#f0f0ec] pt-4 flex flex-col gap-3">
            <a
              href="tel:4086280065"
              className="flex items-center gap-3 text-[#1a1a1a] font-semibold whitespace-nowrap"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-[#d4af37]/10 rounded-full">
                <i className="ri-phone-fill text-[#d4af37]"></i>
              </div>
              (408) 628-0065
            </a>
            <button
              onClick={() => handleNav('#contact')}
              className="bg-[#d4af37] text-[#1a1a1a] font-bold text-xs px-6 py-3 rounded uppercase tracking-[1.5px] cursor-pointer whitespace-nowrap w-full"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Get Free Estimate
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
